import { render, staticRenderFns } from "./PermissionModel.vue?vue&type=template&id=7e72d8a6&scoped=true"
import script from "./PermissionModel.vue?vue&type=script&lang=js"
export * from "./PermissionModel.vue?vue&type=script&lang=js"
import style0 from "./PermissionModel.vue?vue&type=style&index=0&id=7e72d8a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e72d8a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e72d8a6')) {
      api.createRecord('7e72d8a6', component.options)
    } else {
      api.reload('7e72d8a6', component.options)
    }
    module.hot.accept("./PermissionModel.vue?vue&type=template&id=7e72d8a6&scoped=true", function () {
      api.rerender('7e72d8a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PermissionModel.vue"
export default component.exports